<template>
    <div class="parkTem">
        <nav-igation class="nav white"></nav-igation>
        <div class="banner" :style="{ backgroundImage: `url(${require('../../image/' + imgRou + 'parkBack.jpg')})` }">
            <h3> Real business and real capital promote <br> production and city integration </h3>
            <div>真商实资 促产融城</div>
            <p>
                北京小招云有限公司，是一家主要从事空地规划招商、土地调规盘活、闲置资产处置、园区运营管理的重资产市场化招商引资服务商。
北京小招云重点打造的“中云工业园”品牌采用“统规自建+双保姆+陪伴成长”服务模式，专注于为地区规划高质量工业园区，并进行优质重资产招商引资建设，促进地方产业链提质升级，助力实体经济高质量发展。
            </p>
        </div>
        <div class="parkwhat">
            <img src="@/image/news2.jpg" v-if="device == 'ipad' || device == 'm'" style="margin-bottom: 50px;" alt="">
            <div class="leftText">
                <div class="title">
                    <div>中云工业园是什么?</div>
                    <p> What is Zhongyun Industrial Park? </p>
                </div>
                <div class="conTest">
                    有别于传统的招商中介和工业地产开发商，中云工业园可以做到从项目线索到项目投产的全流程管理，入园企业与政府直签，并按照统一规划图纸进行建设。一方面帮助政府分析规划产业落地方向、打造园区建设标准、招引优质企业入驻，从而建立起招商引资全流程解决方案。另一方面为入驻企业提供手续代办、厂房设计等系统服务，帮助企业高效落地投产的同时，降低投资成本。
                    项目以“小而美、专而精、小巨人”作为执行理念，能够真正做到以真实企业落地结果为导向，建立起区域工业发展根基，项目特色包含：
                    -市场化重资产招商。聚焦国民生产制造业，深耕“高端装备制造、生物产业、食品加工产业、新材料产业、新能源汽车产业”等专精产业方向。
                    -全流程落地管理，敢为结果负责。中云工业园可以做到从项目线索到项目投产的全流程管理。项目签订对赌协议，敢于承诺合作园区在限期内招满企业并落地投产。
                </div>
            </div>
            <img src="@/image/news2.jpg" v-if="device == ''" alt="">
        </div>
        <div class="positioning">
            <div class="title">
                <p>精准定位，科学选商</p>
                <p> Accurate positioning, scientific selection </p>
            </div>
            <div class="canvas">
                <div class="left">
                    <div class="itemInfo">
                        <h3>专业规划</h3>
                        <div>
                            <p>园区规划</p>
                            <p>入园规划</p>
                            <p>产业规划</p>
                        </div>
                        <img src="@/image/posi1.png" alt="">
                    </div>
                    <div class="itemInfo">
                        <h3>数字化管理</h3>
                        <div>
                            <p>园区运营管理</p>
                            <p>招商管理</p>
                            <p>流程管理</p>
                        </div>
                        <img src="@/image/posi2.png" alt="">
                    </div>
                </div>
                <div class="content">
                    <img src="@/image/posiAuto.png" alt="">
                </div>
                <div class="right">
                    <div class="itemInfo">
                        <h3>真商实资</h3>
                        <div>
                            <p>高标准产业数据库</p>
                            <p>精准匹配高质量项目</p>
                        </div>
                        <div style="margin-top: 5px;">
                            <p>专业团队促进招商实效</p>
                            <p>契合地方发展需求</p>
                        </div>
                        <img src="@/image/posi3.png" alt="">
                    </div>
                    <div class="itemInfo">
                        <h3>全程维保</h3>
                        <div>
                            <p>入园审核</p>
                            <p>手续代办</p>
                            <p>安全生产</p>
                            <p>施工监理</p>
                        </div>
                        <img src="@/image/posi4.png" alt="">
                    </div>
                </div>
            </div>
            <p>中云工业园生态体系持续 <br> 陪伴关注发展</p>
        </div>
        <div class="synergy">
            <div class="title">
                <p>降本增效 促产达效</p>
                <p>REDUCE COST, INCREASE EFFICIENCY, PROMOTE <br> PRODUCTION AND ACHIEVE EFFECT</p>
            </div>
            <div class="itemView">
                <div>
                    <img src="@/image/synergy1.jpg" alt="">
                    <div class="info">
                        <div class="tit">
                            <h3>统规自建</h3>
                            <p>园区统一规划企业自筹建厂</p>
                        </div>
                        <div class="line"></div>
                        <div class="con">
                            <p>政府:产业及园区精准定位
                                科学选商，高效入驻</p>
                            <p>企业: 提供产业技术支持高端人才输送，政策方向指导等专业服务</p>
                        </div>
                    </div>
                </div>
                <div>
                    <img src="@/image/synergy2.jpg" alt="">
                    <div class="info">
                        <div class="tit">
                            <h3>双保姆服务</h3>
                            <p>政府三招三引企业发展升级政企协同纽带</p>
                        </div>
                        <div class="line"></div>
                        <div class="con">
                            <p>统一规划园区总平及厂房土地利用合理高效</p>
                            <p>清晰核算企业投资，降低投资压力，轻装投产</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="standard">
            <div class="title">
                <h3>中云工业园项目执行标准</h3>
                <p>IMPLEMENTATION STANDARD OF ZHONGYUN INDUSTRIAL <br> PARK PROJECT</p>
                <a :href="downloadUrl" download="政府信息收集表.xlsx" style="text-decoration: none;">
                    <div @click="download()">点击获取政府信息收集表</div>
                </a>
            </div>
            <div class="itemView">
                <div class="item">
                    <img src="@/image/sta1.png" alt="">
                    <p><span>01</span>项目评估</p>
                </div>
                <div class="item">
                    <img src="@/image/sta2.png" alt="">
                    <p><span>02</span>落地规划</p>
                </div>
                <div class="item">
                    <img src="@/image/sta3.png" alt="">
                    <p><span>03</span>签约招商</p>
                </div>
                <div class="item">
                    <img src="@/image/sta4.png" alt="">
                    <p><span>04</span>项目运营</p>
                </div>
            </div>
        </div>

        <div id="inPark">
            <div class="parkwhat">
                <div class="leftText">
                    <div class="title">
                        <div>{{ itemData.name }}</div>
                        <p>{{ itemData.engName }}</p>
                    </div>
                    <div class="line"></div>
                    <div class="conTest">
                        {{ itemData.content }}
                    </div>
                </div>
                <img :src="itemData.cover" alt="">
            </div>
            <div class="imgUl">
                <img @click="parkClick(1)" src="@/image/parkLeft.png" class="parkLeft" alt="">
                <div>
                    <div ref="parkView" :style="{marginLeft:-(liWidth * parkIndex) + 'px'}">
                        <img v-for="(item, index) in parkList" :key="index + 'park'" :src="item.cover"
                            @click="itemData = item" alt="">
                    </div>
                </div>
                <img @click="parkClick(-1)" src="@/image/parkRight.png" class="parkRight" alt="">
                <!-- <img src="@/image/inPark1.jpg" @click="parkUrl = require('@/image/inPark1.jpg')" alt="">
                <img src="@/image/inPark2.jpg" @click="parkUrl = require('@/image/inPark2.jpg')" alt="">
                <img src="@/image/inPark3.jpg" @click="parkUrl = require('@/image/inPark3.jpg')" alt="">
                <img src="@/image/inPark4.jpg" @click="parkUrl = require('@/image/inPark4.jpg')" alt=""> -->
            </div>
        </div>
        <div>
            <Footer></Footer>
        </div>
    </div>
</template>
<script>
import { getPark } from '@/api/home.js'
export default {
    name: 'home',
    data() {
        return {
            parkList: [],
            parkIndex: 0,
            liWidth:0,
            parkUrl: require('@/image/inPark1.jpg'),
            itemData: {},
            downloadUrl: `${process.env.BASE_API}/static/downloa.xlsx`, // 模板下载文件地址
            device: '',
            imgRou: '',//图片引入端 默认pc 
        }
    },
    mounted() {
        var vw = window.screen.width
        if (vw <= 1224) {
            this.device = 'ipad'
            this.imgRou = 'i-'
        }
        if (vw <= 750) {
            this.device = 'm'
            this.imgRou = 'm-'
        }
        this.init()
    },
    methods: {
        parkClick(val) {
            var i = this.parkIndex + val
            console.log(i)
            if (i < 0 || i > (this.parkList.length - 4)) {
                return;
            } else {
                this.parkIndex = i
            }
        },
        init() {
            getPark().then(res => {
                this.parkList = res.data
                this.itemData = res.data[0]
                setInterval(() => {
                    
                }, 10);
                var then = this
                this.$nextTick(()=>{
                    var dom = this.$refs.parkView.getElementsByTagName('img')[0]
                    dom.onload = function(){
                        var val = dom.width
                        console.log(val)
                        then.liWidth = val + val/23*2.66
                    }
                })
            })
        },
        download() {

        }
    }
}
</script>
<style lang="scss" scoped>
// 中云工业园
.parkTem {
    width: 100vw;
    overflow: hidden;
}

.nav {
    position: fixed;
    left: 0;
    top: 0;
    background: #fff;
}

#inPark {
    width: 100%;
    background-image: url(../../image/inPark.jpg);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 125px;

    .line {
        width: 55px;
        height: 6px;
        background: #2EA7E0;
        margin-top: 50px;
    }

    .parkwhat {
        // width: calc(100% - 400px);
        width: auto;
        margin: 120px 200px 50px 200px;

        img {
            width: 50%;
            flex-shrink: 0;
        }
    }

    .imgUl {
        margin: 0px 200px;
        position: relative;

        >div{
            overflow: hidden;
            >div {
            width: 100%;
            display: flex;
            align-items: center;
            transition: 0.3s ease;

            img {
                width: 23%;
                margin-left: 2.66%;
                cursor: pointer;
            }

            img:nth-child(1) {
                margin-left: 0;
            }
        }
        } 

        .parkLeft {
            width: 40px;
            position: absolute;
            left: -60px;
            top: 50%;
            margin-top: -20px;
        }

        .parkRight {
            width: 40px;
            position: absolute;
            right: -60px;
            top: 50%;
            margin-top: -20px;
        }

    }

    .leftText {
        flex: 1;
        .title {
            padding-left: 0;
            border: none;
        }
    }
}

.standard {
    width: 100%;
    background-image: url(../../image/standard.jpg);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 125px;

    .title {
        text-align: center;

        h3 {
            font-size: 23px;
            font-weight: 600;
            color: #ffffff;
            line-height: 33px;
            margin-top: 80px;
        }

        p {
            font-size: 16px;
            color: #fff;
            margin-top: 8px;
        }

        div {
            width: 167px;
            height: 31px;
            background: linear-gradient(270deg, #00AAFF 0%, #4D5EFA 49%, #A259FB 100%);
            cursor: pointer;
            font-size: 11px;
            color: #FFFFFF;
            text-align: center;
            line-height: 30px;
            margin: auto;
            margin-top: 23px;
        }
    }

    .itemView {
        display: flex;
        width: 75%;
        margin-top: 100px;
        justify-content: space-between;

        .item {
            width: 23%;
            background: #fff;

            img {
                width: 100%;
            }

            p {
                font-size: 19px;
                font-weight: 500;
                color: #000000;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 20px 0 40px 0;
                text-align: center;

                span {
                    font-size: 22px;
                    font-weight: 800;
                    color: #2EA7E0;
                    display: block;
                    margin-right: 10px;
                }
            }
        }
    }
}

.synergy {
    width: 100%;
    background-image: url(../../image/synergy.jpg);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .itemView {
        width: 65%;
        display: flex;
        margin-top: 50px;
        margin-bottom: 100px;

        >div {
            width: 30vw;
            margin: 0 30px;

            img {
                width: 100%;

            }

            .info {
                .tit {
                    h3 {
                        font-size: 19px;
                        font-weight: 600;
                        color: #303133;
                        margin-top: 25px;
                    }

                    p {
                        font-size: 14px;
                        color: #606266;
                        margin-top: 8px;
                    }
                }

                .line {
                    width: 47px;
                    height: 2px;
                    background: #2EA7E0;
                    margin-top: 20px;
                }

                .con {
                    display: flex;
                    margin-top: 20px;

                    p {
                        font-size: 14px;
                        color: #303133;
                        display: flex;
                        padding-right: 60px;
                    }

                    p:before {
                        content: '';
                        display: block;
                        width: 6px;
                        height: 6px;
                        background: #2EA7E0;
                        border-radius: 50%;
                        flex-shrink: 0;
                        margin-top: 8px;
                        margin-right: 10px;
                    }
                }
            }
        }
    }

    .title {
        margin-top: 90px;

        p {
            font-size: 30px;
            font-weight: 600;
            color: #303133;
            text-align: center;
            margin-top: 16px;
        }

        p:nth-child(2) {
            font-size: 20px;
            font-weight: 400;
        }
    }
}

.positioning {
    width: 100%;
    background-image: url(../../image/positioning.jpg);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    >p {
        font-size: 16px;
        color: #fff;
        margin-top: 21px;
        text-align: center;
        margin-bottom: 60px;
    }

    .canvas {
        margin-top: 94px;
        display: flex;

        .content {
            img {
                width: 377px;
            }

        }

        .left {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            margin-right: 20px;

            .itemInfo img {
                right: -60px;
            }
        }

        .right {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            margin-left: 20px;

            .itemInfo {
                text-align: left;

                img {
                    left: -60px;
                }
            }
        }



        .itemInfo {
            width: 327px;
            height: 109px;
            background: linear-gradient(270deg, #1641EA 0%, #5D1DFB 100%);
            border-radius: 13px;
            position: relative;
            text-align: right;

            h3 {
                font-size: 19px;
                font-weight: 600;
                color: #ffffff;
                padding-top: 16px;
                margin: 0 31px;
            }

            div {
                display: flex;
                justify-content: space-evenly;
                font-size: 13px;
                color: #ffffff;
                line-height: 17px;
                margin-top: 15px;
            }

            img {
                width: 58px;
                position: absolute;
                top: 10px;
            }
        }
    }

    .title {
        width: 70%;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        margin-top: 78px;

        p:nth-child(1) {
            font-size: 23px;
            font-weight: 600;
            color: #ffffff;
            margin-bottom: 8px;
        }
    }
}

.parkwhat {
    width: calc(100% - 300px);
    margin: 120px 150px;
    display: flex;
    align-items: flex-start;

    .leftText {
        margin-right: 100px;

        .conTest {
            margin-top: 40px;
        }

        .title {
            border-left: 3px solid rgba(46, 167, 224, 1);
            height: 86px;
            padding-left: 43px;

            div {
                font-size: 28px;
                font-weight: 800;
                color: #303133;
            }

            p {
                font-size: 18px;
                font-weight: 500;
                color: #303133;
                margin-top: 17px;
            }
        }
    }

    .conTest {
        font-size: 13px;
        font-weight: 400;
        color: #606266;
        line-height: 32px;
    }

    >img {
        width: 40%;
        height: auto;
    }
}

.banner {
    width: 100%;
    height: 700px;
    margin-top: 80px;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;

    h3,
    div,
    p {
        margin: 0 auto;
        width: 52%;
        text-align: center;
    }

    h3 {
        font-size: 40px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;
        margin-top: 140px;
    }

    div {
        font-size: 72px;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 94px;
        letter-spacing: 4px;
        margin-top: 18px;
    }

    p {
        font-size: 16px;
        color: #FFFFFF;
        line-height: 28px;
        margin-top: 39px;
    }
}</style>


// WEBPACK FOOTER //
// src/pages/park/index.vue